import React, { forwardRef } from 'react';
import { Plus, ArrowUp } from 'lucide-react';
import ModelSelector from '../../../components/ModelSelector';
import VoiceInputButton from '../../../components/VoiceInputButton';
import { MESSAGES_BASE_SPACING } from '../../constants/layout';

const SKELETON_WIDTHS = ['w-full', 'w-[82%]', 'w-[95%]', 'w-[70%]', 'w-[88%]', 'w-[93%]', 'w-[62%]', 'w-[78%]'];

const ShareLoader = forwardRef(function ShareLoader(
    {
        inputSectionHeight,
        selectedModel,
        onModelChange,
        isVoiceInputEnabled,
        isMobile,
        modelSelectorEnabled,
    },
    inputSectionRef,
) {
    return (
        <>
            <div
                className="absolute inset-0 overflow-y-auto auto-hide-scrollbar px-4 sm:px-8 messages-padding-top"
                style={{ paddingBottom: `${inputSectionHeight + 16}px` }}
            >
                <div className="max-w-3xl w-full mx-auto">
                    <div style={{ height: `${MESSAGES_BASE_SPACING}px` }} />
                    <div className="relative overflow-hidden">
                        <div className="flex justify-end mb-8">
                            <div className="h-10 bg-app-hover animate-pulse rounded-2xl w-56" />
                        </div>
                        <div className="space-y-3">
                            {SKELETON_WIDTHS.map((w, i) => (
                                <div key={i} className={`h-4 bg-app-hover animate-pulse rounded-full ${w}`} />
                            ))}
                        </div>
                        <div
                            className="absolute bottom-0 left-0 right-0 h-40 pointer-events-none"
                            style={{ background: 'linear-gradient(to top, var(--app-bg) 10%, transparent 100%)' }}
                        />
                    </div>
                </div>
            </div>

            <div
                className="fixed sm:absolute bottom-0 left-0 right-0 pt-0 pb-2 px-4 sm:px-8 z-10"
                style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}
                ref={inputSectionRef}
            >
                <div
                    className="absolute bottom-0 left-4 right-4 pointer-events-none"
                    style={{
                        height: '180px',
                        WebkitMaskImage: 'linear-gradient(transparent, #000 5rem)',
                        maskImage: 'linear-gradient(transparent, #000 5rem)',
                    }}
                >
                    <div className="absolute -left-4 -right-4 bottom-0 top-0 overflow-hidden">
                        <div className="absolute w-full h-full bg-app-bg"></div>
                    </div>
                </div>

                <div className="max-w-3xl w-full mx-auto relative z-[1]">
                    <div
                        className="relative border border-gray-200/80 rounded-[24px] bg-white shadow-[0_2px_16px_rgba(0,0,0,0.06)]"
                        style={{ padding: '12px 16px', paddingBottom: '12px' }}
                    >
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            <textarea
                                className="w-full resize-none text-base focus:outline-none placeholder-gray-500 bg-transparent disabled:bg-transparent"
                                placeholder="Hỏi bất kỳ điều gì"
                                rows={1}
                                disabled
                                style={{
                                    minHeight: '24px',
                                    overflow: 'hidden',
                                    whiteSpace: 'pre-wrap',
                                    wordWrap: 'break-word',
                                    overflowWrap: 'break-word',
                                }}
                            />
                        </div>
                        <div className="flex items-center justify-between mt-2">
                            <div className="flex items-center gap-2">
                                <button
                                    className="w-7 h-7 flex items-center justify-center rounded-full border border-gray-200 text-gray-400 cursor-not-allowed"
                                    disabled
                                >
                                    <Plus className="w-3.5 h-3.5" strokeWidth={2} />
                                </button>
                                {modelSelectorEnabled && (
                                    <ModelSelector
                                        selectedModel={selectedModel}
                                        onModelChange={onModelChange}
                                        disabled
                                    />
                                )}
                            </div>
                            <div className="flex items-center gap-2">
                                {isVoiceInputEnabled && (
                                    <VoiceInputButton onClick={() => {}} disabled hideTooltip={isMobile} />
                                )}
                                <div className="relative w-7 h-7 flex-shrink-0">
                                    <button
                                        className="w-7 h-7 rounded-full flex items-center justify-center bg-gray-200 text-gray-400 cursor-not-allowed"
                                        disabled
                                    >
                                        <ArrowUp className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default ShareLoader;
